module.exports = __webpack_public_path__ + "static/media/LI11.e07f4425.jpg";